import { getSize } from '../theme/iconSizes'
import IconProps from './Icon'

const ArrowRight = ({ iconSize, strokeWidth = 3, stroke = 'currentColor' }: IconProps) => {
  const size = getSize(iconSize)

  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <polyline points="7 1 17 12 7 23" stroke={stroke} strokeWidth={strokeWidth} />
      </g>
    </svg>
  )
}

export default ArrowRight
